/**
 * Succeed staff GET /user?product=7 response (course-planner-ui userSession parity).
 * @see course-planner-ui/packages/staff/src/CoursePlanner/modules/userSession
 */

export enum SucceedUserLevel {
  DISTRICT = 'DISTRICT',
  SCHOOL_DISTRICT = 'SCHOOL_DISTRICT',
  SCHOOL_INDIVIDUAL = 'SCHOOL_INDIVIDUAL',
  NO_PRODUCT = 'NO_PRODUCT',
}

/** Product id for Course Planner Next — same as c-p-ui `PRODUCT.COURSE_PLANNER_NEXT`. */
export const SUCCEED_PRODUCT_COURSE_PLANNER_NEXT = 7;

export interface SucceedUserSessionResponse {
  /** Authenticated staff user ID (distinct from contactId). */
  id?: number;
  districtId?: string;
  highschoolId?: string;
  /** Canonical SucceedUserType numeric value; e.g. 2 = DISTRICT, 3 = SCHOOL. */
  type?: number;
  /** Keys are product ids as strings in JSON (e.g. `"7"`). */
  products?: Record<string, SucceedUserLevel | string | null | undefined>;
  permissions?: Array<string | number>;
  email?: string;
}
